import React, { Component } from 'react';
import ConnectWithVia from './ConnectWithVia';
import UploadProfile from './UploadProfile';
import UploadLicense from './UploadLicense';
import UploadEligibility from './UploadEligibility';
import UploadSSN from './UploadSSN';
import ReviewProfile from './ReviewProfile';

class SectionSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (() => {
      switch (this.props.currentStep) {
        case 0:
          return <ConnectWithVia {...this.props} />;
        case 1:
          return <UploadProfile {...this.props} />;
        case 2:
          return <UploadLicense {...this.props} />;
        case 3:
          return <UploadEligibility {...this.props} />;
        case 4:
          return <UploadSSN {...this.props} />
        case 5:
        case 6:
          return <ReviewProfile {...this.props} />;
        default:
          return null;
      }
    })();
  }
}

export default SectionSelector;



// WEBPACK FOOTER //
// ./src/components/NycApply/SectionSelector.js